import useProfile from "@/hooks/useProfile";
import { useTranslation } from "react-i18next";

function RoleChip() {
  const { t } = useTranslation();
  const { role } = useProfile();
  const roleString = role === 0 ? t("admin") : t("assessor");

  return (
    <span className="rounded-full bg-cool-gray-200 to-blue-gray-600 px-2 py-1 text-xs font-bold">
      {roleString}
    </span>
  );
}

export default RoleChip;
